import Vue from 'vue';
import { PreApplyItem } from '@/po/PreApplyItem';
import { RouterV2Enum } from '@/router/router-names';
import RouterHelper from '@/shared/utils/routerHelper';
import { OrderResultEnum } from '@/enums/orderV2';

export const handleChannelClick = (
  vueInstance: Vue, channel: PreApplyItem, ubtName: string, applyStatus: OrderResultEnum,
): void => {
  // 更换提现渠道
  vueInstance.$ubtPageButton(
    ubtName,
    '产品',
    channel.productId,
    'applyStatus',
    applyStatus,
  );

  // 申请提现其他渠道
  const applyProduct = `${RouterV2Enum.applyProduct}?commodityId=${channel.productId}&source=fundsdrawfail`;

  if (!RouterHelper.backToPath(applyProduct)) {
    vueInstance.$router.replace(applyProduct);
  }
};
